module.exports = __webpack_public_path__ + "static/media/erecht24-disclaimer.e59130a9.png";